import RadioButtonGroupView from './RadioButtonGroup.view';
export * from './RadioButtonGroup.view';

export const RadioButtonGroup = (props) => RadioButtonGroupView(props);

export default RadioButtonGroup;

